<template>
    <main class="test">
        <hk-header></hk-header>
        <div class="test-content">
            <div class="test-container">
                <div class="test-container-top">
                    <h2 class="test-title">{{ questionMsg.paperName }}</h2>
                    <p class="teacher-subject">
                        授课老师：{{ questionMsg.teacherName }} / 科目：【
                        {{ questionMsg.subjectName }} 】
                    </p>
                    <div class="attention">
                        <h4>注意事项</h4>
                        <p>请于规定时间内作答，时间结束后立即收卷</p>
                    </div>
                </div>
                <div class="test-container-content">
                    <ul class="question">
                        <li
                            v-for="(item, index) in questionList"
                            :key="index"
                            class="question-item"
                        >
                            <p v-mathjax="item.title" class="title">
                                {{
                                    `${index + 1}、【${
                                        item.type === 1
                                            ? '单选题'
                                            : item.type === 2
                                            ? '多选题'
                                            : '问答题'
                                    }】 ${item.title}`
                                }}
                            </p>
                            <p v-if="item.images" class="question-img">
                                <img :src="item.images" alt="" />
                            </p>
                            <el-radio-group
                                v-if="item.type === 1"
                                v-model="item.answer"
                                class="single"
                            >
                                <el-radio
                                    v-for="(option, k) in item.options"
                                    :key="k"
                                    :label="option.optionId"
                                >
                                    {{ defaultOption[k] + '、'
                                    }}<span v-mathjax="option.optionContent"></span>
                                </el-radio>
                                <p v-if="item.option1_img" class="option-img">
                                    <img :src="item.option1_img" alt="" />
                                </p>
                            </el-radio-group>
                            <el-checkbox-group
                                v-if="item.type === 2"
                                v-model="item.answer"
                                class="multiple"
                            >
                                <el-checkbox
                                    v-for="(option, k) in item.options"
                                    :key="k"
                                    :label="option.optionId"
                                >
                                    {{ defaultOption[k] + '、'
                                    }}<span v-mathjax="option.optionContent"></span>
                                </el-checkbox>
                                <p v-if="item.option1_img" class="option-img">
                                    <img :src="item.option1_img" alt="" />
                                </p>
                            </el-checkbox-group>
                        </li>
                    </ul>
                </div>
            </div>
            <div ref="suspension" class="suspension">
                <p class="count-down">
                    用时 <span class="count-down-time">{{ timeText }}</span>
                </p>
                <div class="time-count">
                    <p class="time">时间：{{ time }}分钟</p>
                    <p class="question-count">题目数：{{ questionList.length }}</p>
                </div>
                <p class="hand-paper" @click="handPaper">交卷</p>
            </div>
        </div>
        <hk-footer></hk-footer>
        <hk-dialog
            :state.sync="dialogState"
            title="确认提交"
            buttonText="提交"
            @close="closeDialog"
            @confirm="confirm"
        >
            <template #content>
                <p class="complete-text">我已完成测试，确认交卷</p>
            </template>
        </hk-dialog>
        <hk-dialog
            :state.sync="attentionState"
            title="温馨提示"
            buttonText="确认"
            @close="backEvent"
            @confirm="backEvent"
        >
            <template #content>
                <p class="complete-text">{{ dialogMsg }}</p>
            </template>
        </hk-dialog>
    </main>
</template>

<script>
import HkHeader from '@components/HkHeader';
import HkFooter from '@components/HkFooter';
import HkDialog from '@components/HkDialog';
import { getQuestions, answerQuestion } from '@api/test';
import { getDocumentTop } from '@helpers/scroll-event';
export default {
    components: {
        HkHeader,
        HkFooter,
        HkDialog
    },
    data() {
        return {
            questionMsg: {
                title: '有理数的加减法 - 随堂测试',
                teacher: '乐意',
                subject: '数学'
            },
            questionList: [],
            time: 0,
            countDownFun: '',
            timeText: '',
            left: 0,
            answers: [],
            spentTime: 0,
            dialogState: false,
            attentionState: false,
            dialogMsg: '',
            defaultOption: ['A', 'B', 'C', 'D', 'E']
        };
    },
    computed: {
        scheduleId() {
            return this.$route.query.scheduleId;
        }
    },
    created() {
        this.getQuestion();
    },
    mounted() {
        this.countDownScroll();
    },
    beforeDestroy() {
        clearInterval(this.countDownFun);
        window.removeEventListener('scroll', this.getScroll);
    },
    methods: {
        countDown() {
            let timer = this.time * 60;
            this.timeText = this.initTime(timer);
            this.countDownFun = setInterval(() => {
                if (timer > 0) {
                    timer--;
                    this.spentTime = timer;
                    this.timeText = this.initTime(timer);
                } else {
                    this.confirm();
                    clearInterval(this.countDownFun);
                }
            }, 1000);
        },
        countDownScroll() {
            this.left = this.$refs['suspension'].getBoundingClientRect().left;
            window.addEventListener('scroll', this.getScroll);
        },
        getScroll(e) {
            let top = getDocumentTop();
            if (top > 38) {
                // console.log(111)
                this.$refs['suspension'].style.position = 'fixed';
                this.$refs['suspension'].style.left = this.left - 8 + 'px';
                this.$refs['suspension'].style.top = '80px';
            } else {
                this.$refs['suspension'].style.position = 'absolute';
                this.$refs['suspension'].style.left = '';
                this.$refs['suspension'].style.right = 0;
                this.$refs['suspension'].style.top = 0;
            }
        },
        initTime(time) {
            let h = parseInt(time / 60 / 60, 10);
            let m = parseInt(time / 60, 10);
            let s = parseInt(time % 60, 10);
            return `${h >= 10 ? h : '0' + h}:${m >= 10 ? m : '0' + m}:${s >= 10 ? s : '0' + s}`;
        },
        handPaper() {
            if (this.questionList.length === 0) {
                return;
            }
            this.dialogState = true;
        },
        async getQuestion() {
            // const scheduleId = 26;

            await getQuestions(this.scheduleId)
                .then((res) => {
                    this.time = res.data.duration;
                    this.questionList = res.data.questions.map((item) => {
                        let answer = null;
                        if (item.type === 1) {
                            answer = null;
                        } else if (item.type === 2) {
                            answer = [];
                        }
                        item.answer = answer;
                        return item;
                    });
                    this.questionMsg = res.data.paperInfo;
                    this.countDown();
                })
                .catch((error) => {
                    this.attentionState = true;
                    this.dialogMsg = error.message;
                });
        },
        closeDialog() {
            this.dialogState = false;
        },
        backEvent() {
            this.$router.back();
        },
        confirm() {
            this.answers = this.questionList.map((item) => ({
                id: item.id,
                answer: item.answer
            }));
            this.answers.forEach((item) => {
                let type = Object.prototype.toString.call(item['answer']);
                if (type === '[object Number]') {
                    item['answer'] = JSON.stringify([item['answer']]);
                } else if (type === '[object Array]') {
                    item['answer'] = JSON.stringify(item['answer']);
                }
            });
            let costTime = this.time - Math.floor(this.spentTime / 60);
            answerQuestion({
                scheduleId: this.scheduleId,
                answers: JSON.stringify(this.answers),
                duration: costTime
            }).then((res) => {
                // this.$router.replace({name: 'analysis',query: {scheduleId: this.scheduleId}});
                if (res.status === 'success') {
                    this.$trackEvent('答题', '结束答题', this.scheduleId);
                    this.$router.replace({
                        name: 'Analysis',
                        query: { scheduleId: this.scheduleId }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.test {
    width: 100%;
    min-width: 1200px;
    background-color: #f8fafc;
    padding-top: 60px;
    &-content {
        width: 1200px;
        margin: 38px auto 0;
        position: relative;
        .test-container {
            box-sizing: border-box;
            width: 816px;
            padding: 70px 65px;
            margin: 0 auto;
            background-color: #fff;
            box-shadow: 0px 5px 7px 0px #eaedf7;
            border-radius: 14px;
            &-top {
                .test-title {
                    font-size: 24px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    color: #333333;
                    line-height: 39px;
                    text-align: center;
                }
                .teacher-subject {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 30px;
                    text-align: center;
                }
                .attention {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 34px;
                    background: #fffdf1;
                    border: 1px solid #e4d5bf;
                    margin-top: 16px;
                    h4 {
                        width: 95px;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 800;
                        color: #333333;
                        border-right: 1px solid #e4d5bf;
                    }
                    p {
                        padding-left: 10px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #666666;
                    }
                }
            }
            &-content {
                margin-top: 25px;
                .title {
                    font-size: 16px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333333;
                    line-height: 36px;
                    margin-bottom: 20px;
                }
                .question-img {
                    padding: 0 0 30px 35px;
                }
                .option-img {
                    margin-bottom: 25px;
                }
                &::v-deep {
                    .el-radio-group,
                    .el-checkbox-group {
                        box-sizing: border-box;
                        padding-left: 35px;
                    }
                    .el-radio {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .el-radio__label {
                            color: #333;
                            font-size: 16px;
                            display: flex;
                            align-items: center;
                        }
                        .el-radio__inner {
                            width: 20px;
                            height: 20px;
                        }
                        .el-radio__inner::after {
                            width: 11px;
                            height: 8px;
                            background: url('~@images/base/right-icon.png') no-repeat center;
                        }
                        .el-radio__input.is-checked .el-radio__inner {
                            border-color: #b22fb0;
                            background: #b22fb0;
                        }
                        .el-radio__inner:hover {
                            border-color: #b22fb0;
                        }
                    }
                    .el-checkbox {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                        .el-checkbox__label {
                            color: #333;
                            font-size: 16px;
                            display: flex;
                            align-items: center;
                        }
                        .el-checkbox__inner {
                            width: 18px;
                            height: 18px;
                        }
                        .el-checkbox__inner::after {
                            border: 2px solid #fff;
                            border-left: 0;
                            border-top: 0;
                            top: 2px;
                            left: 6px;
                        }
                        .el-checkbox__input.is-checked .el-checkbox__inner {
                            border-color: #b22fb0;
                            background: #b22fb0;
                        }
                        .el-checkbox__inner:hover {
                            border-color: #b22fb0;
                        }
                    }
                }
            }
        }
        .suspension {
            box-sizing: border-box;
            width: 170px;
            height: 190px;
            background: #ffffff;
            box-shadow: 0px 5px 7px 0px #eaedf7;
            border-radius: 14px;
            position: absolute;
            right: 0;
            top: 0;
            padding: 22px 20px 30px;
            .count-down {
                width: 100%;
                height: 24px;
                line-height: 24px;
                padding-left: 26px;
                background: url('~@images/base/clock-icon.png') no-repeat left center;
                color: #999;
                font-size: 16px;
                margin-bottom: 9px;
                &-time {
                    color: #ec4444;
                }
            }
            .time-count {
                padding: 9px 14px 11px;
                background: #f6f8fb;
                .time,
                .question-count {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #333333;
                }
                .time {
                    margin-bottom: 15px;
                }
            }
            .hand-paper {
                width: 100%;
                height: 32px;
                text-align: center;
                line-height: 32px;
                background: #ce51cb;
                box-shadow: 0px 5px 7px 0px #eaedf7;
                border-radius: 16px;
                color: #fff;
                font-size: 16px;
                color: #fff;
                margin-top: 7px;
                cursor: pointer;
            }
        }
    }
    .complete-text {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999;
    }
}
</style>
